<app-banner [loading]="loading" [info]="true" [heading]="'Notifications'" [subHeading]="'View all notifications received from registrants.'">


  <div class="toolbar-content">

    @if (!layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(true)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-maximize"></i>
        <span>maximise</span>
      </button>
    }

    @if (layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(false)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-restore"></i>
        <span>restore</span>
      </button>
    }


  </div>

</app-banner>
<app-collapsible [trigger]="searchVisible">
  <div class="content no-boxes search-bar">


    <div style="flex-grow: 1">

      @if (searchByOwnerNumber) {
        <div class="form-inline reg-number">
          <input #regNumber (keydown.enter)="search()" placeholder="Owner number..." [(ngModel)]="searchCriteria.ownerNumber"
            type="text" name="ownerNumber" class="form-control " />
            <button class="btn btn-primary ml-2" [disabled]="!searchCriteria.ownerNumber" (click)="search()">Search</button>
            <button class="btn btn-default ml-2" [disabled]="!searchCriteria.ownerNumber" (click)="clearSearch()">Clear</button>
          </div>
        }

        @if (searchByRegNumber) {
          <div class="form-inline reg-number">
            <input #regNumber (keydown.enter)="search()" placeholder="Registration number..." [(ngModel)]="searchCriteria.regNumber"
              type="text" name="regNumber" class="form-control " />
              <button class="btn btn-primary ml-2" [disabled]="!searchCriteria.regNumber" (click)="search()">Search</button>
              <button class="btn btn-default ml-2" [disabled]="!searchCriteria.regNumber" (click)="clearSearch()">Clear</button>
            </div>
          }

          @if (searchByPreEntryNumber) {
            <div class="form-inline reg-number">
              <input #regNumber (keydown.enter)="search()" placeholder="Pre-entry number..." [(ngModel)]="searchCriteria.preEntryNumber"
                type="text" name="preEntryNumber" class="form-control " />
                <button class="btn btn-primary ml-2" [disabled]="!searchCriteria.preEntryNumber" (click)="search()">Search</button>
                <button class="btn btn-default ml-2" [disabled]="!searchCriteria.preEntryNumber" (click)="clearSearch()">Clear</button>
              </div>
            }
          </div>

          <mat-radio-group [(ngModel)]="searchBy" (ngModelChange)="setFocus()">
            <mat-radio-button [value]="SearchOption.RegNumber">Registration number</mat-radio-button>
            <mat-radio-button [value]="SearchOption.PreEntryNumber">Pre-entry number</mat-radio-button>
            <mat-radio-button [value]="SearchOption.OwnerNumber">Owner number</mat-radio-button>
          </mat-radio-group>

        </div>

      </app-collapsible>

      @if (!loading) {
        <div class="content no-boxes fadein">
          @if (notifications?.length) {
            <div style="padding-bottom: 20px">
              <h4>Notifications sent to {{ notificationOwner }}</h4>
              <!--  <div class="form-group reg-number">
              <input type="text" [(ngModel)]="notificationType" name="notificationType" placeholder="Filter based on notification type"
                class="form-control" />
              </div>-->
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 100px">Date of Notification</th>
                    <th style="width: 200px">Notification type</th>
                    @if (searchCriteria.ownerNumber) {
                      <th style="width: 100px"></th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (notification of notifications | searchPipe:notificationType; track notification; let i = $index) {
                    <tr class="clickable">
                      @if (!searchCriteria.ownerNumber) {
                        <td> {{ notification.dateOfNotification | utcDate }} </td>
                      }
                      @if (searchCriteria.ownerNumber) {
                        <td> {{ notification.notificationDate | utcDate }} </td>
                      }
                      @if (!searchCriteria.ownerNumber) {
                        <td> {{ NotificationType[notification.type] | caseSplit }} </td>
                      }
                      @if (searchCriteria.ownerNumber) {
                        <td> {{ getNotificationType(notification.type) }} </td>
                      }
                      @if (searchCriteria.ownerNumber) {
                        <td (click)="viewNotificationDetails(i)"> View </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          @else{
            <div class="no-data">
              There are currently no notifications to display
            </div>
          }
        </div>
      }